import { Api } from '../api';
import {   IResponseLogOrg } from 'shared/types';

 


const getAllLogs = async (filter = ''): Promise<IResponseLogOrg | Error> => {
  try{
   
    const { data, status } = await Api.get(`/OrgLog/${filter !== '' ? '?' : ''}${filter}`);   

    
    if (data) {
      return data;
    }

    if (status === 204) {
      return {rows:[],count: 0};
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao listar os registros.');
  }
};

const getById = async (id: string): Promise<IResponseLogOrg | Error> => {
  try {
    const { data } = await Api.get(`/OrgLog/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {

    console.error(error);
    return new Error((error as { message: string }).message || 'Erro ao consultar o registro.');
  }
};



export const LogService = {
  
  getAllLogs,
  getById
};
